import {
    format,
    subDays,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
    subWeeks,
    subMonths,
    subQuarters,
    subYears,
    addDays,
    addWeeks,
    addMonths
} from 'date-fns';

export const ISSUE_DATE_MODES = {
    ON_SEND: 'on_send',
    SCHEDULED: 'scheduled'
};

export const SCHEDULE_INVOICE_PRESET_DATES = [
    {
        label: 'Tomorrow',
        date: format(addDays(new Date(), 1), 'yyyy-MM-dd')
    },
    {
        label: 'Next monday',
        date: format(addWeeks(startOfWeek(new Date(), { weekStartsOn: 1 }), 1), 'yyyy-MM-dd')
    },
    {
        label: 'Last day of this month',
        date: format(endOfMonth(new Date()), 'yyyy-MM-dd')
    },
    {
        label: 'First day of next month',
        date: format(startOfMonth(addMonths(new Date(), 1)), 'yyyy-MM-dd')
    }
];

// Past-only date-range presets for reports (Product sales, Customer sales).
// Computed lazily so a long-open tab never serves stale "to date" ranges.
export const getReportRangePresets = () => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const weekOpts = { weekStartsOn: 1 }; // Monday

    return [
        { label: 'Last 7 days', start: subDays(today, 6), end: today },
        { label: 'Last 30 days', start: subDays(today, 29), end: today },
        { label: 'This week', start: startOfWeek(today, weekOpts), end: today },
        { label: 'This month', start: startOfMonth(today), end: today },
        { label: 'This quarter', start: startOfQuarter(today), end: today },
        { label: 'This year', start: startOfYear(today), end: today },
        { label: 'Last week', start: startOfWeek(subWeeks(today, 1), weekOpts), end: endOfWeek(subWeeks(today, 1), weekOpts) },
        { label: 'Last month', start: startOfMonth(subMonths(today, 1)), end: endOfMonth(subMonths(today, 1)) },
        { label: 'Last quarter', start: startOfQuarter(subQuarters(today, 1)), end: endOfQuarter(subQuarters(today, 1)) },
        { label: 'Last year', start: startOfYear(subYears(today, 1)), end: endOfYear(subYears(today, 1)) },
    ];
};

export const ISSUE_DATE_PRESET_DATES = [
    {
        label: 'Last Month',
        date: format(subDays(new Date(), 30), 'yyyy-MM-dd')
    },
    {
        label: 'Yesterday',
        date: format(subDays(new Date(), 1), 'yyyy-MM-dd')
    },
    {
        label: 'Today',
        date: format(new Date(), 'yyyy-MM-dd')
    },
    {
        label: 'Tomorrow',
        date: format(addDays(new Date(), 1), 'yyyy-MM-dd')
    },
    {
        label: 'Next monday',
        date: format(addWeeks(startOfWeek(new Date(), { weekStartsOn: 1 }), 1), 'yyyy-MM-dd')
    },
    {
        label: 'Last day of this month',
        date: format(endOfMonth(new Date()), 'yyyy-MM-dd')
    },
    {
        label: 'First day of next month',
        date: format(startOfMonth(addMonths(new Date(), 1)), 'yyyy-MM-dd')
    },
];
